const US_PHONE_DIGITS = 10;

/**
 * Reduces anything a user can type or paste to the ten digits of a US number.
 *
 * Pasted numbers routinely arrive as `+1 (555) 555-5555`; the country code is
 * implied for the only locale this product serves, so it is dropped rather than
 * counted against the length.
 */
export function normalizeUsPhone(value: string | null | undefined): string {
  const digits = (value ?? "").replace(/\D/g, "");
  const national =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return national.slice(0, US_PHONE_DIGITS);
}

/** Formats as far as the digits go, so the mask builds up while typing. */
export function formatUsPhone(value: string | null | undefined): string {
  const digits = normalizeUsPhone(value);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Empty is not invalid — the phone field is optional; callers check that first. */
export function isValidUsPhone(value: string | null | undefined): boolean {
  return normalizeUsPhone(value).length === US_PHONE_DIGITS;
}
